import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import IconsContext from '../../Context/IconsContext';
import ModalLayout from '../ModalLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default function RunCustomerOTAModalDisplay(props) {
  const { customerOTAselected } = props;
  const { commandControlIcon } = useContext(IconsContext);

  return (
    <ModalLayout
      centered
      isOpen={props.isOpen}
      size="lg"
      toggle={props.toggleModal}
    >
      <ModalHeader className="pb-0 border-bottom-0" toggle={props.toggleModal}>
        <img
          src={commandControlIcon}
          alt="command icon"
          className="img-fluid mx-auto"
          style={{ height: '4rem' }}
        />
        <p className="mb-0 modal-title-text text-center">
          Run Customer OTA on gateway
        </p>
      </ModalHeader>
      <ModalBody className="p-3 px-md-4 container-fluid">
        <div className="row justify-content-center mt-3">
          <p className="col-12 col-md-10 text-left text-muted">
            The OTA file will be downloaded and run by the gateway. status will
            be reported in the command history tab
          </p>
        </div>
        <div className="row justify-content-center mt-3">
          <p className="col-12 col-md-10 text-left text-muted">
            selected: {customerOTAselected.typeName}{' '}
            {customerOTAselected.filename},{' '}
            {customerOTAselected.properties.contentLength} bytes, created{' '}
            {customerOTAselected.createdOn} ago
          </p>
        </div>
        {customerOTAselected.type === 'hfx_flash' ? (
          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-10">
              <div className="form-group">
                <label className="text-muted" htmlFor="source_address">
                  Target CAN Bus
                </label>
                <div
                  className="col-6 form-group mb-2"
                  data-for="can"
                  data-tip="CAN bus for the target HFX module"
                >
                  <select
                    className="form-control form-control-sm w-auto"
                    name="canbus"
                    onBlur={props.handlePropUpdate}
                    onChange={props.handlePropUpdate}
                    type="select"
                    value={props.canbus}
                  >
                    <option value={'0'}>can0</option>
                    <option value={'1'}>can1</option>
                    <option value={'2'}>can2</option>
                    <option value={'3'}>can3</option>
                  </select>
                </div>
                <div className="col-6 form-group mb-2">
                  <input
                    checked={props.setSourceAddress}
                    className="form-check-input"
                    id="isSetSourceAddress"
                    onChange={props.handleSetSourceAddress}
                    type="checkbox"
                  />
                  <label
                    className="form-check-label text-text-light-gray"
                    htmlFor="set-source-address"
                  >
                    set source address? (if unset, any HFX module on the bus
                    will be flashed)
                  </label>
                </div>
                {props.setSourceAddress ? (
                  <div className="col-6 form-group mb-2">
                    <label className="text-muted" htmlFor="source_address">
                      Target J1939 Source Address
                    </label>
                    <input
                      aria-describedby="saHelp"
                      className="form-control form-control-sm w-25"
                      max="255"
                      min="0"
                      name="source_address"
                      onChange={props.handleSourceAddressUpdate}
                      type="number"
                      value={props.source_address}
                    />
                    <small id="saHelp" className="form-text text-muted">
                      Source Address for the target HFX module
                    </small>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
        <div className="row justify-content-center">
          <p className="col-12 col-md-10 text-danger three-quarter-text text-right">
            {props.error}
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-between border-0 px-md-4">
        <button
          className="btn btn-outline-secondary px-4 py-0 nine-tenth-text"
          onClick={props.toggleModal}
        >
          Cancel
        </button>
        <button
          className="btn modal-button-submit px-4 py-0 nine-tenth-text"
          onClick={props.handleExecuteCustomerOTA}
        >
          {props.executeRequestPending ? (
            <FontAwesomeIcon icon={faCircleNotch} spin size="lg" />
          ) : (
            'Execute'
          )}
        </button>
      </ModalFooter>
      <style jsx global>{`
        .modal-title {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          justify-content: center;
          margin-right: -1.5rem;
        }
      `}</style>
    </ModalLayout>
  );
}

RunCustomerOTAModalDisplay.propTypes = {
  error: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  canbus: PropTypes.number,
  source_address: PropTypes.string,
  handlePropUpdate: PropTypes.func,
  handleSourceAddressUpdate: PropTypes.func,
  handleExecuteCustomerOTA: PropTypes.func,
  executeRequestPending: PropTypes.bool,
  setSourceAddress: PropTypes.bool,
  handleSetSourceAddress: PropTypes.func,
  customerOTAselected: PropTypes.shape({
    filename: PropTypes.string, // just the filename
    displayName: PropTypes.string, // the filename but maybe truncated for display
    name: PropTypes.string, // blob storage name
    type: PropTypes.string, // just the prefix like "hfx_flash"
    typeName: PropTypes.string, // name found from looking up in our types table
    properties: PropTypes.object, // from blob storage
    createdOn: PropTypes.string, // "x ago" string from properties.createdOn time
  }),
};

RunCustomerOTAModalDisplay.defaultProps = {};
